export default "__VITE_ASSET__EU3k0lCg__"